<div class="container pgcontent">
  <div class="pt-5 pb-4 ndc-registration"
    *ngFor="let cardSection of cardSectionsMap | keyvalue : orderByAdditionalOrderField">
    <h3>{{ cardSection.key }}</h3>
    <div class="row">
      <div *ngFor="let cards of cardSection.value">
        <div *ngFor="let card of cards">
          <div *ngIf="card.noteSections.length > 0" class="col-lg-12">
            <div class="info-panel" *ngFor="let noteSection of card.noteSections">
              <div style="display: flex">
                <i [ngClass]="noteSection.iconClass || ''">&nbsp;</i>
                <small><strong>{{ noteSection.title }}</strong></small>
              </div>
              <p style="margin: 0" [innerHTML]="noteSection.body | mdToHtml"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="row">
        <div class="col-md-4 mt-20" *ngFor="let cards of cardSection.value">
          <div *ngFor="let card of cards">
            <div class="step">
              {{ card.headText }}
            </div>
            <div class="card pt-2">
              <div (click)="setPopUpImage($event, card)" class="inner-container miHi-1" data-bs-toggle="modal"
                data-bs-target="#imagePopUp">
                <div class="card-image-header show-image" style="background-image: url({{ card.headImage }})">&nbsp;
                </div>
              </div>

              <div class="modal fade" id="imagePopUp" tabindex="-1" role="dialog" aria-labelledby="imagePopUpTitle"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <button type="button" class="btn-close close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <img class="img-fluid" style="max-width: 100%; height: auto" [src]="getPopUpImage()" alt="" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-body miHi-2">
                <div>
                  <h3 class="card-title">{{ card.title }}</h3>
                  <p class="card-text" [innerHtml]="returnHtmlFromRichText(card.richTextBody)"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>